// extracted by mini-css-extract-plugin
module.exports = {"card":"DashboardNews_card__3F4Xn"};